import { NgModule } from '@angular/core';
import {
  DxDataGridModule,
  DxMultiViewModule,
  DxRadioGroupModule,
  DxTemplateModule,
  DxSliderModule,
  DxNumberBoxModule,
  DxCheckBoxModule,
  DxFileUploaderModule,
  DxAccordionModule,
  DxTileViewModule,
  DxSelectBoxModule,
  DxSparklineModule,
  DxCircularGaugeModule,
  DxLinearGaugeModule,
  DxBarGaugeModule,
  DxButtonModule,
  DxProgressBarModule,
  DxTabsModule,
} from 'devextreme-angular';

const dev = [
  DxDataGridModule,
  DxMultiViewModule,
  DxRadioGroupModule,
  DxTemplateModule,
  DxSliderModule,
  DxNumberBoxModule,
  DxAccordionModule,
  DxTileViewModule,
  DxSelectBoxModule,
  DxCheckBoxModule,
  DxFileUploaderModule,
  DxSparklineModule,
  DxCircularGaugeModule,
  DxLinearGaugeModule,
  DxBarGaugeModule,
  DxButtonModule,
  DxProgressBarModule,
  DxTabsModule,
];

@NgModule({
  id: 'tech-devextreme-module',
  imports: [dev],
  exports: [dev],
})
export class CustomDevextremeModule {}
